import { Record, List } from 'immutable';

import ValidityPeriod from '../ValidityPeriod';
import OrderLeg from './Leg';
import { construct, fields, resolveAll } from '../../helpers/LinkMapper';

const defaults = {
    id: null,
    validFrom: null,
    validTo: null,
    legs: new List(),
    validityPeriod: null
};

class OrderJourney extends Record(defaults) { // eslint-disable-line new-cap

    static fromJSON (json = {}) {
        return construct(OrderJourney, json, {
            id: fields.string,
            validFrom: fields.datetime,
            validTo: fields.datetime,
            legs: resolveAll.as(OrderLeg),
            validityPeriod: fields.string
        });
    }

    getDepartureTime () {
        let transfer = 0;
        let current = this.legs.first();
        let index = 0;
        while (current && !current.departure) {
            transfer += current.transferTime;
            index++;
            current = this.legs.get(index);
        }

        return current ? current.departure.clone().subtract(transfer, 'minutes') : null;
    }

    getArrivalTime () {
        let transfer = 0;
        let current = this.legs.last();
        let index = this.legs.size - 1;
        while (current && !current.arrival) {
            transfer += current.transferTime;
            index--;
            current = this.legs.get(index);
        }

        return current ? current.arrival.clone().add(transfer, 'minutes') : null;
    }

    getOrigin () {
        return this.legs.first().origin;
    }

    getDestination () {
        return this.legs.last().destination;
    }

    getChanges () {
        return this.legs.size - 1; //TODO: get the api to return this?
    }

    hasSeats () {
        return this.legs.some((leg) => leg.hasSeats());
    }

    getValidityPeriod () {
        return ValidityPeriod.fromString(this.validityPeriod);
    }
}


export default OrderJourney;



// WEBPACK FOOTER //
// ./src/records/order/Journey.js